import Logout from './Logout';

export default Logout;



// WEBPACK FOOTER //
// ./src/containers/Logout/index.js